import axios from 'axios';

export const getAcqAuthToken = async () => {

  return axios.post(
    `${process.env.REACT_APP_BACKEND_DOMAIN}/oauth/token`,
    {
      client_id: process.env.REACT_APP_ACQ_CLIENT_ID,
      client_secret: process.env.REACT_APP_ACQ_CLIENT_SECRET_ID,
      audience: process.env.REACT_APP_ACQ_AUDIENCE,
      grant_type: 'client_credentials',
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};